// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1IyM-","list":"PatternAutocomplete_list__1n0l1"};